import api from './api'
import routes from './routes'
import actions from './actions'

export default {
  API: api,
  ROUTES: routes,
  ACTIONS: actions,
  GROUP_TYPES: {
    SIZE: {
      SIZE: 'SIZE',
      CUSTOM_SIZE: 'CUSTOM_SIZE',
    }
  },
  PART_TITLES: {
    DoorKnob: 'Ручка',
    Latch: 'Задвижка',
    LockCommon: 'Основной замок',
    LockAdditional: 'Дополнительный замок',
    LockPadCommon: 'Накладка на основной замок',
    LockPadAdditional: 'Накладка на дополнительный замок',
    InsideColor: 'Цвет внутренней отделки',
    OutsideColor: 'Цвет внешней отделки',
    InsidePanel: 'Панель',
    ForgedFinish: 'Кованая отделка',
    parts: 'Доп. опции',
    construction: 'Тип конструкции',
    open: 'Сторона открывания',
    size: 'Размеры'
  },
  PART_INDEXES: {
    DoorKnob: 5,
    Latch: 4,
    LockCommon: 4,
    LockAdditional: 4,
    LockPadCommon: 3,
    LockPadAdditional: 3,
    InsideColor: 2,
    OutsideColor: 2,
    InsidePanel: 1,
    ForgedFinish: 3,
    parts: 6,
    construction: 1,
    open: 0,
    size: 0
  }
}


// WEBPACK FOOTER //
// ./app/javascript/app/constants/index.js